export const getProduct = async (id, type) => {
	let data = (await fetch(`/wp-json/namnlappskungen/v1/namnlapp?id=${id}&type=${type}`))

	return (await data.json())
}